var _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _ellipse4, _path8, _path9, _g2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOttoScribblesSleep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 341,
    height: 260,
    viewBox: "0 0 341 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.288,
    cy: 177.408,
    rx: 156.957,
    ry: 38.3504,
    fill: "url(#paint0_radial)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 14.4766,
    ry: 3.80964,
    transform: "matrix(1 -3.4089e-10 -3.4089e-10 -1 174.05 210.981)",
    fill: "url(#paint1_radial)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 14.4766,
    ry: 3.80964,
    transform: "matrix(1 -3.4089e-10 -3.4089e-10 -1 129.35 207.933)",
    fill: "url(#paint2_radial)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.323 131.719C24.3455 55.4609 125.73 72.786 167.119 67.8507C209.481 62.7994 293.494 64.5473 313.042 122.579C332.591 180.611 38.773 219.357 28.323 131.719Z",
    fill: "url(#paint3_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M299.006 182.027C332.531 162.945 326.301 130.319 313.363 108.525C300.424 86.7315 268.337 81.8865 241.694 97.7039C216.197 112.841 204.926 141.414 215.342 162.945L156.84 184.63L165.473 196.035C165.296 196.351 165.132 196.671 164.978 196.996C157.993 211.82 166.17 214.98 171.131 214.708L186.14 210.073L187.159 199.812L258.161 185.879C268.211 185.467 289.206 187.846 299.006 182.027Z",
    fill: "url(#paint4_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.147 192.478C144.987 195.219 159.994 198.781 175.13 199.387C190.55 200.004 199.88 181.004 201.215 171.466L169.236 149.958C170.187 136.034 174.302 110.847 140.934 107.805C134.372 105.058 94.1507 83.0471 86.1431 81.5986C45.8819 74.316 31.555 107.016 26.6818 133.957C21.8086 160.898 50.4962 188.642 90.7573 195.925C108.044 199.052 123.617 197.453 136.147 192.478Z",
    fill: "url(#paint5_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.904 100.383L133.421 118.409L110.685 162.397C110.685 162.397 87.6712 141.616 90.1666 124.226C92.4781 108.117 114.904 100.383 114.904 100.383Z",
    fill: "#CDBF90"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.214 190.443C124.215 174.612 76.4574 173.378 26.3526 141.5C26.3526 149.82 28.5348 163.206 31.0664 177.412C33.598 191.619 86.5354 197.65 95.9639 198.84L116.189 198.025L119.894 208.299L135.58 209.121C140.458 208.172 147.613 203.108 137.214 190.443Z",
    fill: "url(#paint6_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M253.905 205.46C234.483 204.778 212.819 191.456 212.277 179.53C249.601 175.94 302.765 182.589 323.642 144.185C322.231 182.878 273.326 206.142 253.905 205.46Z",
    fill: "url(#paint7_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M204.219 172.839C205.928 166.638 190.87 164.577 190.87 164.577L199.173 178.721C199.173 178.721 203.415 175.757 204.219 172.839Z",
    fill: "#494949"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.07 148.185C149.178 150.69 152.225 148.049 156.116 147.881C160.007 147.713 163.269 150.082 163.161 147.577C163.053 145.072 159.869 144.538 155.979 144.706C152.088 144.874 148.962 145.68 149.07 148.185Z",
    fill: "#3D3D3D"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.353,
    cy: 77.5,
    rx: 84,
    ry: 21.5,
    fill: "url(#paint8_radial)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M248.129 56.6128C253.277 85.6613 217.028 79.7914 168.062 83.4694C119.096 87.1473 96.1146 86.5389 94.7322 68.1349C93.3498 49.7308 114.315 23.491 163.28 19.813C212.246 16.1351 232.161 44.7136 248.129 56.6128Z",
    fill: "url(#paint9_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1008 62.4106C91.8294 77.5896 92.6991 82.356 119.699 82.8389C146.699 83.3217 172.116 96.6562 172.387 81.4773C172.658 66.2983 166.562 44.6408 139.562 44.1579C112.562 43.6751 92.3723 47.2317 92.1008 62.4106Z",
    fill: "url(#paint10_linear)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.156 92.7437L225.147 89.6759C225.147 89.6759 221.403 86.5311 221.559 84.5216C221.756 81.9843 227.929 79.7631 227.929 79.7631L241.35 82.4754C241.35 82.4754 244.498 86.6253 243.578 89.0868C242.836 91.0714 239.156 92.7437 239.156 92.7437Z",
    fill: "#767676"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.087 46.6375C250.427 45.388 245.012 44.6874 235.353 43.4379C232.561 41.963 229.694 40.7554 226.991 40.1386C222.619 39.1409 217.32 39.3795 212.286 40.1087C212.286 40.1087 190.853 31.5 190.132 33.8411C189.412 36.1823 194.467 46.1338 194.467 46.1338L192.699 68.0206C194.312 79.7596 212.665 90.5302 217.009 91.2651C221.353 92 241.246 88.9159 246.674 79.0087L251.564 57.2309C251.564 57.2309 269.746 47.887 260.087 46.6375Z",
    fill: "url(#paint11_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M235.934 72.023C235.641 73.5042 233.739 71.5873 231.03 71.0499C228.321 70.5125 225.653 73.9912 225.947 72.51C226.241 71.0287 228.694 68.6352 231.402 69.1726C234.111 69.71 236.228 70.5418 235.934 72.023Z",
    fill: "#3D3D3D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M214.592 70.715C214.435 72.2169 213.164 68.4803 210.417 68.1929C207.671 67.9056 205.287 69.1745 205.445 67.6726C205.602 66.1707 207.87 66.002 210.617 66.2893C213.363 66.5767 214.749 69.2131 214.592 70.715Z",
    fill: "#3D3D3D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M218.293 81.5384C218.636 82.0872 219.402 82.1703 219.855 81.7079L223.267 78.224C223.852 77.6275 223.491 76.6201 222.661 76.5301L216.663 75.8793C215.833 75.7892 215.264 76.6958 215.707 77.4037L218.293 81.5384Z",
    fill: "#C5AAAA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M229.194 51.4605L230.353 41L234.853 43L229.194 51.4605Z",
    fill: "#676767"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M216.208 49.5963L212.353 40L216.853 39.6468L216.208 49.5963Z",
    fill: "#676767"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M221.247 62.2924L228.853 40.5C228.853 40.5 226.318 39.7524 224.14 39.4265C221.961 39.1006 218.119 39.3773 218.119 39.3773L221.247 62.2924Z",
    fill: "#676767"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.0301 70.1853C95.6829 66.6904 99.8559 65.1971 103.351 66.8499C118.266 73.9036 158.784 87.9416 201.915 76.2449C205.646 75.233 209.491 77.4375 210.503 81.1687C211.515 84.8999 209.311 88.7449 205.579 89.7568C157.887 102.691 113.732 87.2458 97.3656 79.506C93.8707 77.8532 92.3774 73.6802 94.0301 70.1853Z",
    fill: "url(#paint12_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M112.282 74.1016L106.459 83.2173L111.382 84.8808L112.282 74.1016Z",
    fill: "#676767"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.585 84.317L126.057 74.9862L121.074 73.5114L120.585 84.317Z",
    fill: "#676767"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M100.989 76.1106L108.353 69L104.353 67.5L100.989 76.1106Z",
    fill: "#676767"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M140.926 88.759L144.956 78.7213L139.81 78L140.926 88.759Z",
    fill: "#676767"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M163.031 91.6555L166.353 81L160.353 80.5L163.031 91.6555Z",
    fill: "#676767"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M182.442 90.7653L182.853 80L178.353 80.5L182.442 90.7653Z",
    fill: "#676767"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M132.593 80.5383L127.853 90L132.593 91L132.593 80.5383Z",
    fill: "#676767"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M151.931 83.0552L148.463 93.3006L153.64 93.736L151.931 83.0552Z",
    fill: "#676767"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M173.756 84.3429L171.853 94.7234L176.353 94.5L173.756 84.3429Z",
    fill: "#676767"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M246.643 35.321L252.254 36.5474L252.637 34.7989L249.989 34.2203L249.996 34.187L253.246 31.5298L253.552 30.131L248.14 28.9483L247.758 30.6968L250.455 31.2864L250.448 31.3197L246.919 34.0555L246.643 35.321Z",
    fill: "#A5B4FC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M259.8 27.2852L265.413 26.0639L265.032 24.315L262.384 24.8913L262.377 24.858L264.226 21.0889L263.921 19.6898L258.508 20.8677L258.889 22.6165L261.587 22.0294L261.594 22.0627L259.524 26.0194L259.8 27.2852Z",
    fill: "#A5B4FC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M251.713 10.6302L256.638 13.5872L257.559 12.0527L255.235 10.6576L255.253 10.6284L259.182 9.15042L259.919 7.92288L255.17 5.0712L254.249 6.60563L256.616 8.02708L256.599 8.05631L252.38 9.51955L251.713 10.6302Z",
    fill: "#A5B4FC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M149.206 96.5867L157.624 98.4263L158.197 95.8035L154.225 94.9356L154.236 94.8857L159.111 90.8999L159.57 88.8017L151.452 87.0277L150.879 89.6504L154.925 90.5347L154.914 90.5847L149.621 94.6884L149.206 96.5867Z",
    fill: "#CAD3FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M167.72 85.7105L176.14 83.8785L175.569 81.2552L171.597 82.1196L171.586 82.0696L174.359 76.416L173.902 74.3174L165.783 76.0842L166.354 78.7075L170.401 77.8268L170.412 77.8768L167.307 83.8118L167.72 85.7105Z",
    fill: "#CAD3FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M155.481 63.1119L162.868 67.5474L164.25 65.2457L160.764 63.1531L160.791 63.1092L166.685 60.8923L167.79 59.051L160.666 54.7735L159.284 57.0751L162.835 59.2073L162.809 59.2511L156.481 61.446L155.481 63.1119Z",
    fill: "#CAD3FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 62.3809,
    y: 87.4373,
    width: 82.8633,
    height: 98.6678,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 216.633,
    y: 75.5178,
    width: 32.2246,
    height: 22.9753,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(173.288 177.408) rotate(90) scale(38.3504 156.957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4766 3.80964) rotate(90) scale(3.80964 14.4766)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4766 3.80964) rotate(90) scale(3.80964 14.4766)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 170.401,
    y1: 68.754,
    x2: 179.037,
    y2: 166.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0C394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEB183"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 230.086,
    y1: 167.551,
    x2: 268.436,
    y2: 90.5959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2B588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481077,
    stopColor: "#D8CA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9BB8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 189.392,
    y1: 173.132,
    x2: 27.1245,
    y2: 150.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDBF90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 30.3983,
    y1: 156.793,
    x2: 138.718,
    y2: 198.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBF90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4D8AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 230.773,
    y1: 194.418,
    x2: 317.589,
    y2: 162.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6C99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9BB8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.353 77.5) rotate(90) scale(21.5 84)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 164.303,
    y1: 19.7362,
    x2: 179.776,
    y2: 86.9731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 144.117,
    y1: 91.4496,
    x2: 132.081,
    y2: 45.5169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 225.194,
    y1: 39.7849,
    x2: 217.362,
    y2: 91.9649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 95.2168,
    y1: 71.2365,
    x2: 211.03,
    y2: 79.5057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9C9C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOttoScribblesSleep);
export default __webpack_public_path__ + "static/media/otto-scribbles-sleep.4317add604b2fae93b6ddd01b79d3285.svg";
export { ForwardRef as ReactComponent };